import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore';
import { useScreenStore } from '../../stores/useScreenStore';
import { usePermissions } from './usePermissions';

export function useOnboardingGuard(step) {
    
    const navigate = useNavigate();

    const perfisSelecionados = useAuthStore(state => state.perfisSelecionados);
    const user = useAuthStore(state => state.user);
    const {
        canSelectProfiles: needsProfiles,
        canSelectDualMonitor: needsMonitor,
    } = usePermissions();

    const monitorMode = useScreenStore(state => state.monitorMode);

    const hasProfiles = perfisSelecionados?.length > 0;
    const hasMonitorMode = monitorMode !== 0;
    const isDualMonitor = monitorMode === 2;

    useEffect(() => {

        if(!user){
            return;
        }

        if (step === 'profile') {

            if (needsProfiles && !hasProfiles) return;

            if (needsMonitor && !hasMonitorMode) {
                navigate('/selecionar-monitores', { replace: true });
                return;
            }

            navigate('/', { replace: true });
            return;
        }

        if (step === 'monitor') {

            if (needsProfiles && !hasProfiles) {
                navigate('/selecionar-perfil', { replace: true });
                return;
            }

            if (hasMonitorMode || !needsMonitor) {
                navigate('/', { replace: true });
                return;
            }
        }

        if (step === 'home') {

            if (needsProfiles && !hasProfiles) {
                navigate('/selecionar-perfil', { replace: true });
                return;
            }

            if (needsMonitor && !hasMonitorMode) {
                navigate('/selecionar-monitores', { replace: true });
                return;
            }
        }

    }, [
        user,
        step,
        hasProfiles,
        hasMonitorMode,
        needsProfiles,
        needsMonitor,
        navigate
    ]);

    const canRender = {

        profile:
            needsProfiles && !hasProfiles,

        monitor: (!needsProfiles || hasProfiles) &&
            needsMonitor && !hasMonitorMode,

        home:
            (!needsProfiles || hasProfiles) &&
            (!needsMonitor || hasMonitorMode),

        filters:
            (!needsProfiles || hasProfiles) &&
            needsMonitor &&
            hasMonitorMode &&
            isDualMonitor

    }[step] ?? false;

    return {
        hasProfiles,
        hasMonitorMode,
        isDualMonitor,
        canRender
    };
}